import { render } from "./UnionWithCircle.svg?vue&type=template&id=6f3dc7fa"
const script = {}
script.render = render

export default script